import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e201f45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-4xl p-10 mx-auto bg-white rounded-lg mobile:shadow-md mobile:mt-10 mobile:mb-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mx-auto text-4xl font-bold text-left" }, "Welcome to Contributr.", -1))
const _hoisted_3 = { class: "max-w-2xl mt-6 text-left" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-8 mt-8 tablet:grid-cols-3" }
const _hoisted_5 = { class: "stepNumber px-3.5 py-2 mr-4 w-11 z-10 font-semibold" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.message), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepsOverview, (step) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${step.number}-${step.imageName}`
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(step.number), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(step.description), 1),
          _createElementVNode("img", {
            src: require(`@/assets/images/${step.imageName}.png`),
            class: "mt-4"
          }, null, 8, _hoisted_7)
        ]))
      }), 128))
    ])
  ]))
}